import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Image } from 'react-bootstrap';

interface Props {
  message: string;
  avatar?: string;
}

const ToastMessage: FC<Props> = ({ message, avatar = '' }: Props) => {
  const intl = useIntl();
  return (
    <React.Fragment>
      <div className="toast-image">
        {avatar && (
          <Image
            src={avatar}
            className="avatar"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.hidden = true;
            }}
            roundedCircle
          />
        )}
      </div>
      <div>
        <span>{message ? message : intl.formatMessage({ id: 'errors.generic' })}</span>
      </div>
    </React.Fragment>
  );
};

export default ToastMessage;
